/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { CustomerOrderStatusEnumType } from "./CustomerOrderStatusEnum"
import { RootStoreType } from "./index"


/**
 * CustomerOrderDtoBase
 * auto generated base class for the model CustomerOrderDtoModel.
 */
export const CustomerOrderDtoModelBase = ModelBase
  .named('CustomerOrderDto')
  .props({
    __typename: types.optional(types.literal("CustomerOrderDto"), "CustomerOrderDto"),
    createdOn: types.union(types.undefined, types.string),
    customerOrderNumber: types.union(types.undefined, types.null, types.string),
    /** Completion date, scheduled stop date, or unscheduled delivery date, preserving its local offset. */
    date: types.union(types.undefined, types.null, types.string),
    id: types.identifier,
    projectId: types.union(types.undefined, types.integer),
    routificOrderNumber: types.union(types.undefined, types.string),
    status: types.union(types.undefined, CustomerOrderStatusEnumType),
    uuid: types.union(types.undefined, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class CustomerOrderDtoModelSelector extends QueryBuilder {
  get createdOn() { return this.__attr(`createdOn`) }
  get customerOrderNumber() { return this.__attr(`customerOrderNumber`) }
  get date() { return this.__attr(`date`) }
  get id() { return this.__attr(`id`) }
  get projectId() { return this.__attr(`projectId`) }
  get routificOrderNumber() { return this.__attr(`routificOrderNumber`) }
  get status() { return this.__attr(`status`) }
  get uuid() { return this.__attr(`uuid`) }
}
export function selectFromCustomerOrderDto() {
  return new CustomerOrderDtoModelSelector()
}

export const customerOrderDtoModelPrimitives = selectFromCustomerOrderDto().createdOn.customerOrderNumber.date.projectId.routificOrderNumber.status.uuid
